var map = {
	"./help-blue.svg": "i1fG",
	"./help-gray.svg": "kZcT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oY8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/help\-.*\.svg$
// module id = oY8b
// module chunks = 46